import { render } from "./MasterBoardSubBoardTasksModal.vue?vue&type=template&id=32e5af58&scoped=true"
import script from "./MasterBoardSubBoardTasksModal.vue?vue&type=script&lang=js"
export * from "./MasterBoardSubBoardTasksModal.vue?vue&type=script&lang=js"

import "./MasterBoardSubBoardTasksModal.vue?vue&type=style&index=0&id=32e5af58&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-32e5af58"

export default script